import { t } from 'i18next'
import { type PropsWithChildren } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import Button from '@components/designSystem/Button'
import { Headline } from '@components/designSystem/Headline'

export function RouterErrorBoundary() {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    return (
      <ErrorSection>
        <h3>
          {error.status} {error.statusText}
        </h3>
        <p>{error.data}</p>
      </ErrorSection>
    )
  } else if (error instanceof Error) {
    return (
      <ErrorSection>
        <p>{error.message}</p>
        <p>The stack trace is:</p>
        <pre>{error.stack}</pre>
      </ErrorSection>
    )
  } else {
    return (
      <ErrorSection/>
    )
  }
}

function ErrorSection({ children }: PropsWithChildren){
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6">
      <Headline i18nKey='common.error.serverError.message' />
      {children}
      <Button size='xl' onClick={()=>{window.location.reload()}}>
        {t('common.error.serverError.action')}
      </Button>
    </div>
  )
}